<div class="card">
    <p-toast></p-toast>
    <p-steps [model]="items" [readonly]="false"></p-steps>
</div>
<router-outlet></router-outlet>